import { Archive } from "react-feather";
import { Button } from "risa-oasis-ui_v2";

/**
 * Props for {@link SupportTicketContentHeader}.
 */
interface SupportTicketContentHeaderProps {
  onNewTicketClick?: () => void;
  /** Whether the archived-tickets view is currently active. */
  isArchiveActive?: boolean;
  /** Toggles between the active and archived ticket lists. */
  onArchiveToggle?: () => void;
}

/**
 * Top action row for the support ticket content area.
 *
 * @param props - Header callbacks and archive-toggle state.
 * @returns Archive toggle and Add New action aligned to the top right.
 */
const SupportTicketContentHeader = ({
  onNewTicketClick,
  isArchiveActive = false,
  onArchiveToggle,
}: SupportTicketContentHeaderProps) => {
  return (
    <div className="support-tickets-content-header flex shrink-0 items-center justify-end gap-2 pb-3">
      <button
        type="button"
        aria-label={isArchiveActive ? "Show active tickets" : "Show archived tickets"}
        aria-pressed={isArchiveActive}
        onClick={onArchiveToggle}
        className={`flex cursor-pointer items-center justify-center rounded-md border p-2 transition-colors ${
          isArchiveActive
            ? "border-gray-700 bg-gray-800 hover:bg-gray-700"
            : "border-gray-300 bg-white hover:bg-gray-50"
        }`}
      >
        <Archive
          width="18"
          height="18"
          stroke={isArchiveActive ? "#FFFFFF" : "#475467"}
        />
      </button>
      <Button
        buttonType="primary"
        size="medium"
        onClick={onNewTicketClick ?? (() => {})}
        disabled={false}
      >
        Add New
      </Button>
    </div>
  );
};

export default SupportTicketContentHeader;
